import { ICustomPropertiesElement } from '../components/CustomProperty/types';
import { TCustomPropertyId } from '../../../../../../types/types';
import { CUSTOM_ERROR_DUPLICATE, CUSTOM_ERROR_EMPTY } from '../components/CustomPropertiesForm/constants';

export const getCustomPropertyValid = (
    elements: ICustomPropertiesElement[],
    setElements: (elements: ICustomPropertiesElement[]) => void,
): boolean => {
    const names = elements.map(item => trimLow(item.name));
    const namesDeduplicated = [...new Set(names)];
    const duplicateIds: TCustomPropertyId[] = [];
    const emptyIds: TCustomPropertyId[] = [];
    if (names.length !== namesDeduplicated.length) {
        elements.forEach(item => {
            if (!duplicateIds.includes(item.id)) {
                const nameTrim = trimLow(item.name);
                const elementDuplicates = elements.filter(element => trimLow(element.name) === nameTrim);
                if (elementDuplicates.length > 1) {
                    elementDuplicates.forEach(item => duplicateIds.push(item.id));
                }
            }
        });
    }
    elements.forEach(item => {
        const nameTrim = trimLow(item.name);
        if (nameTrim === '') emptyIds.push(item.id);
    });
    setElements(elements.map(item => ({
        ...item,
        error: emptyIds.length && emptyIds.includes(item.id)
            ? CUSTOM_ERROR_EMPTY
            : duplicateIds.length && duplicateIds.includes(item.id) ? CUSTOM_ERROR_DUPLICATE : null,
    })));
    return !emptyIds.length && !duplicateIds.length;
}

/**
 * удалить все пробелы и в нижний регистр
 */
export const trimLow = (value: string): string => {
    return value.replace(/\s/g, '').toLocaleLowerCase();
}
